import _classCallCheck from '../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../@babel/runtime/helpers/esm/createClass.js';
import { PropertyCommitter, EventPart, BooleanAttributePart, AttributeCommitter, NodePart } from './parts.js';

/**
 * Creates Parts when a template is instantiated.
 */
var DefaultTemplateProcessor = /*#__PURE__*/function () {
  function DefaultTemplateProcessor() {
    _classCallCheck(this, DefaultTemplateProcessor);
  }
  _createClass(DefaultTemplateProcessor, [{
    key: "handleAttributeExpressions",
    value:
    /**
     * Create parts for an attribute-position binding, given the event, attribute
     * name, and string literals.
     *
     * @param element The element containing the binding
     * @param name  The attribute name
     * @param strings The string literals. There are always at least two strings,
     *   event for fully-controlled bindings with a single expression.
     */
    function handleAttributeExpressions(element, name, strings, options) {
      var prefix = name[0];
      if (prefix === '.') {
        var _committer = new PropertyCommitter(element, name.slice(1), strings);
        return _committer.parts;
      }
      if (prefix === '@') {
        return [new EventPart(element, name.slice(1), options.eventContext)];
      }
      if (prefix === '?') {
        return [new BooleanAttributePart(element, name.slice(1), strings)];
      }
      var committer = new AttributeCommitter(element, name, strings);
      return committer.parts;
    }
    /**
     * Create parts for a text-position binding.
     * @param templateFactory
     */
  }, {
    key: "handleTextExpression",
    value: function handleTextExpression(options) {
      return new NodePart(options);
    }
  }]);
  return DefaultTemplateProcessor;
}();
var defaultTemplateProcessor = new DefaultTemplateProcessor();

export { DefaultTemplateProcessor, defaultTemplateProcessor };
